import { RouterProvider } from 'react-router-dom';

import { router } from './app/router.js';

export function App(): JSX.Element {
  return <RouterProvider router={router} />;
}
